export default {
    props: {
        value: {
            type: [String, Number, Date, Object],
            default: ""
        },

        label: {
            type: String,
            default: ""
        },

        rules: {
            type: String,
            default: ""
        },

        description: {
            type: String,
            default: ""
        },

        name: {
            type: String,
            default: ""
        },

        placeholder: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            localValue: this.value
        };
    },
    methods: {
        update() {
            this.$emit("input", this.localValue);
        }
    },
    watch: {
        value(newValue) {
            this.localValue = newValue;
        }
    }
};
